declare global {
  interface Window {
    fbq: (type: 'track' | 'trackCustom', event: string, data?: unknown) => void;
  }
}

const init = (id: string): void => {
  if (document.getElementById('kaaja-facebook-jssdk')) return;

  const script = document.createElement('script');
  script.id = 'kaaja-facebook-jssdk';
  script.innerHTML = `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${id}');
    fbq('track', 'PageView');`;
  document.body.prepend(script);
};

const viewContent = (data: unknown): void => {
  window.fbq && window.fbq('track', 'ViewContent', data);
};

const track = (event: string, params?: unknown): void => {
  window.fbq && window.fbq('track', event, params);
};

const trackCustom = (event: string, params?: unknown): void => {
  window.fbq && window.fbq('trackCustom', event, params);
};

export const FacebookPixel = {
  init,
  track,
  trackCustom,
  viewContent,
};
